import { Breakpoint, Button, ButtonSize, ButtonTheme, TypographyVariant } from '@elearning-platform/ui';
import React from 'react';
import { TransProps, useTranslation } from 'react-i18next';
import { useMediaQuery } from 'react-responsive';

import ShapeDesktop from './images/shape.desktop.svg';
import ShapeMobile from './images/shape.mobile.svg';
import {
  ButtonWrapper,
  ContentContainer,
  DesktopShape,
  EmptyShape,
  GridContainer,
  MobileShape,
  SupportingText,
  Title,
  Wrapper,
} from './introSlide.styled';
import { IntroSlideProps } from './introSlide.types';

export const IntroSlide: React.FC<IntroSlideProps> = (props: IntroSlideProps): JSX.Element => {
  const { data, onButtonClick }: IntroSlideProps = props;
  const isSmallDesktop: boolean = useMediaQuery({
    query: Breakpoint.SmallDesktop,
  });
  const isDesktop: boolean = useMediaQuery({
    query: Breakpoint.Desktop,
  });
  const { t }: TransProps<never> = useTranslation();

  return (
    <Wrapper>
      <GridContainer>
        {!isSmallDesktop ? (
          <>
            <EmptyShape />
            <MobileShape src={ShapeMobile} />
          </>
        ) : (
          <EmptyShape />
        )}
        <ContentContainer>
          <Title variant={isDesktop ? TypographyVariant.DisplayMD : TypographyVariant.DisplaySM}>
            {data.title}
          </Title>
          <SupportingText variant={TypographyVariant.TextMD}>
            {data.supportingText}
          </SupportingText>
        </ContentContainer>
        {!!isSmallDesktop && (
          <DesktopShape src={ShapeDesktop} />
        )}
        <ButtonWrapper>
          <Button
            fullWidth={!isSmallDesktop}
            label={t('competence.app.interactions.timerSlides.componentsV2.introSlide.start')}
            onClick={onButtonClick}
            size={ButtonSize.Large}
            variant={ButtonTheme.PrimaryBrand}
          />
        </ButtonWrapper>
      </GridContainer>
    </Wrapper>
  );
};
